import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import React, { useRef, useState } from "react";
import checkIcon from "../../public/images/home/check-feature.svg";

const UpgradePlan = ({ plan }) => {
  const [showMore, setShowMore] = useState(false);
  const isPaidPlan = () => plan?.price > 0;
  const planBox = useRef();

  const offSet = 160;
  const height = () => planBox?.current.scrollHeight + offSet;

  return (
    <div
      style={{
        height: showMore ? height() : "700px",
      }}
      ref={planBox}
      id="upgrade-plan-box"
      className={`${plan.recommended ? "border-gray-700" : "border-gray-300"}
      }`}
      onMouseEnter={() => isPaidPlan() && setShowMore(true)}
      onMouseLeave={() => isPaidPlan() && setShowMore(false)}
    >
      {plan.recommended && (
        <div className="flex justify-center">
          <div className="recommended">
            <FontAwesomeIcon icon={faStar} />
            <span>Recommended</span>
          </div>
        </div>
      )}
      <div className="title">{plan.plan}</div>
      <div className="description">{plan.description}</div>
      <div className="price-box-wrapper">
        <div className="price">
          {"$"}
          {plan.price}
        </div>
        <div className="flex justify-center mt-4">
          <div className="plan-duration">User / Month</div>
        </div>
      </div>
      <div className="mt-7">
        {plan.features.map((feature, index) => (
          <div key={index}>
            {index < 5 && (
              <div className="flex items-center gap-4 mb-4">
                <Image src={checkIcon.src} width={25} height={25} alt="" />
                <div className="font-bold">{feature}</div>
              </div>
            )}
          </div>
        ))}

        <div className={` ${showMore ? "h-auto visible" : "h-0 invisible"}`}>
          {plan.features.map(
            (feature, index) =>
              index > 4 && (
                <div
                  key={index}
                  className={`hidden-features ${
                    showMore ? "opacity-100" : "opacity-0"
                  }`}
                >
                  <Image src={checkIcon.src} width={25} height={25} alt="" />
                  <div className="font-bold">{feature}</div>
                </div>
              )
          )}
        </div>

        {isPaidPlan() ? (
          <div
            className={`show-more ${showMore ? "opacity-0 " : "opacity-100"}`}
          >
            Hover To See More Details...
          </div>
        ) : (
          <div className="h-[2.7rem]"></div>
        )}

        <div className="flex justify-center">
          <div className="upgrade-btn">
            <span>{plan.buttonLabel}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradePlan;
